import axios from "axios";

const baseURL =
import.meta.env.VITE_PUBLIC_API_URL;
//"http://localhost:8080"
const base_AI_URL = import.meta.env.VITE_PUBLIC_AI_API_URL;

export default axios.create({
  baseURL: baseURL,
  headers: {
    "Content-type": "application/json",
    "Authorization": `Bearer ${typeof window !== 'undefined' ? localStorage.getItem('accessToken') : null}`,
    "User-Type": "user",
    "Environment": typeof window !== 'undefined' ? (JSON.parse(window.localStorage.getItem('isLive') || 'false') ? 'live' : 'test') : 'live'
  },
});

export const httpFormData = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-type": "multipart/form-data",
    "Authorization": `Bearer ${typeof window !== 'undefined' ? localStorage.getItem('accessToken') : null}`,
    "User-Type": "user",
    "Environment": typeof window !== 'undefined' ? (JSON.parse(window.localStorage.getItem('isLive') || 'false') ? 'live' : 'test') : 'live'
  },
});

export const httpAI = axios.create({
  baseURL: base_AI_URL,
  headers: {
    "Content-type": "application/json",
    "Authorization": `Bearer ${typeof window !== 'undefined' ? localStorage.getItem('accessToken') : null}`,
    "User-Type": "user",
    "Environment": typeof window !== 'undefined' ? (JSON.parse(window.localStorage.getItem('isLive') || 'false') ? 'live' : 'test') : 'live'
  },
});

export const httpFormDataAI = axios.create({
  baseURL: base_AI_URL,
  headers: {
    "Content-type": "multipart/form-data",
    "Authorization": `Bearer ${typeof window !== 'undefined' ? localStorage.getItem('accessToken') : null}`,
    "User-Type": "user",
    "Environment": typeof window !== 'undefined' ? (JSON.parse(window.localStorage.getItem('isLive') || 'false') ? 'live' : 'test') : 'live'
  },
});
